import { useMemo } from "react";

const DOTS = "...";
const NO_DOTS_PAGE_LIMIT = 5;
const SIBLING_ITEM_COUNT = 3;

const range = (start, end) => {
  let length = end - start + 1;
  return Array.from({ length }, (_, idx) => idx + start);
};

export const getPaginationRange = (
  currentPage,
  totalCount,
  siblingCount,
  pageSize
) => {
  const totalPageCount = Math.ceil(totalCount / pageSize);

  // Pages count is determined as siblingCount + firstPage + lastPage + currentPage + 2*DOTS
  const totalPageNumbers = siblingCount + NO_DOTS_PAGE_LIMIT;

  /*
          If the number of pages is less than the page numbers we want to show in our
          paginationComponent, we return the range [1..totalPageCount]
        */
  if (totalPageNumbers >= totalPageCount) {
    return range(1, totalPageCount);
  }

  const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
  const rightSiblingIndex = Math.min(
    currentPage + siblingCount,
    totalPageCount
  );

  /*
          We do not want to show dots if there is only one position left 
          after/before the left/right page count as that would lead to a change if our Pagination
          component size which we do not want
        */
  const minimumPagesAtEndToShowDots = 2;
  const shouldShowLeftDots = leftSiblingIndex > minimumPagesAtEndToShowDots;
  const shouldShowRightDots =
    rightSiblingIndex < totalPageCount - minimumPagesAtEndToShowDots;

  const firstPageIndex = 1;
  const dotBalanceFactor = 2;
  const lastPageIndex = totalPageCount;

  if (!shouldShowLeftDots && shouldShowRightDots) {
    let leftItemCount = SIBLING_ITEM_COUNT + dotBalanceFactor * siblingCount;
    let leftRange = range(1, leftItemCount);

    return [...leftRange, DOTS, totalPageCount];
  }

  if (shouldShowLeftDots && !shouldShowRightDots) {
    let rightItemCount = SIBLING_ITEM_COUNT + dotBalanceFactor * siblingCount;
    let rightRange = range(totalPageCount - rightItemCount + 1, totalPageCount);
    return [firstPageIndex, DOTS, ...rightRange];
  }

  if (shouldShowLeftDots && shouldShowRightDots) {
    let middleRange = range(leftSiblingIndex, rightSiblingIndex);
    return [firstPageIndex, DOTS, ...middleRange, DOTS, lastPageIndex];
  }

  return [];
};
